import { Stack } from '@mui/material';
import type {
  Product,
  ProductFamily,
  ServiceStatus,
  ServiceStatusInfo,
} from '../types';
import ProductCard from './ProductCard';
import { Cart, Invoice } from '../features/self-serve/types/types';

const ProductList = ({
  revenue,
  hasExpiredPolicy = false,
  hasRenewedPolicy = false,
  processingProductId,
  products,
  serviceStatusInfos,
  isServiceStatusInfoLoading,
  productFamily,
  isPoolTenant = false,
  cart,
  ctaasServiceStatus,
  isEligibleForFreeCtaas,
  handleAddProductToCart,
  handleAddProductToOpportunity,
  invoices = [],
}: {
  revenue?: number | null;
  hasExpiredPolicy?: boolean;
  hasRenewedPolicy?: boolean;
  processingProductId: string | null;
  products: Product[];
  serviceStatusInfos: ServiceStatusInfo[];
  isServiceStatusInfoLoading: boolean;
  productFamily?: ProductFamily;
  isPoolTenant?: boolean;
  cart: Cart | null;
  ctaasServiceStatus?: ServiceStatus;
  isEligibleForFreeCtaas: boolean;
  handleAddProductToCart: (
    cart: Cart | null,
    product: Product,
    quantity: number,
    hasConfirmedReplacement: boolean
  ) => Promise<void>;
  handleAddProductToOpportunity: (product: Product) => Promise<void>;
  invoices: Invoice[];
}) => {
  return (
    <Stack
      display="grid"
      gridTemplateColumns={{
        xs: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: `repeat(${Math.min(products.length, 2)}, minmax(280px, 320px))`,
        lg: `repeat(${Math.min(products.length, 4)}, minmax(240px, 320px))`,
        xl: `repeat(${Math.min(products.length, 4)}, minmax(320px, 420px))`,
      }}
      direction="row"
      justifyContent="center"
      alignItems="stretch"
      gap={4}
    >
      {products.map((product, idx) => {
        const isProductInCart = cart?.cartItems?.some(
          (item) => item.product.id === product.id
        );

        return (
          <ProductCard
            key={product.id}
            hasExpiredPolicy={hasExpiredPolicy}
            hasRenewedPolicy={hasRenewedPolicy}
            idx={idx}
            processingProductId={processingProductId}
            product={product}
            serviceStatusInfos={serviceStatusInfos}
            isServiceStatusInfoLoading={isServiceStatusInfoLoading}
            productFamily={productFamily}
            isPoolTenant={isPoolTenant}
            isProductInCart={isProductInCart}
            cart={cart}
            ctaasServiceStatus={ctaasServiceStatus}
            isEligibleForFreeCtaas={isEligibleForFreeCtaas}
            handleAddProductToCart={handleAddProductToCart}
            handleAddProductToOpportunity={handleAddProductToOpportunity}
            revenue={revenue}
            products={products}
            invoices={invoices}
          />
        );
      })}
    </Stack>
  );
};

export default ProductList;
